// extracted by css-extract-rspack-plugin
export default {"container":"DashboardLayout_mobile_container__bz1IR"};